import React from 'react'
import Chrome from '#src/components/Chrome'
import { FullBlockLoader, CircleLoader } from '@deal/components'
import useRouter from 'use-react-router'

interface RouteLoaderProps {
  isDepartmentSpecificPage?: boolean | ((route: string) => boolean)
}

const RouteLoader: React.SFC<RouteLoaderProps> = ({ isDepartmentSpecificPage = false }) => {
  const { location } = useRouter()

  if (typeof isDepartmentSpecificPage === 'function') {
    isDepartmentSpecificPage = isDepartmentSpecificPage(location.pathname)
  }

  return (
    <Chrome isDepartmentSpecificPage={isDepartmentSpecificPage}>
      <FullBlockLoader loader={CircleLoader} />
    </Chrome>
  )
}

export default RouteLoader
